"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.padLeft = exports.hasTextContents = exports.hasChordContents = exports.pushNew = void 0;

var _chord_lyrics_pair = _interopRequireDefault(require("./chord_sheet/chord_lyrics_pair"));

var _tag = _interopRequireDefault(require("./chord_sheet/tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var pushNew = function pushNew(collection, Klass) {
  var newObject = new Klass();
  collection.push(newObject);
  return newObject;
};

exports.pushNew = pushNew;

var hasChordContents = function hasChordContents(line) {
  return line.items.some(function (item) {
    return item instanceof _chord_lyrics_pair["default"] && item.chords;
  });
};

exports.hasChordContents = hasChordContents;

var hasTextContents = function hasTextContents(line) {
  return line.items.some(function (item) {
    return item instanceof _chord_lyrics_pair["default"] && item.lyrics || item instanceof _tag["default"] && item.isRenderable();
  });
};

exports.hasTextContents = hasTextContents;

var padLeft = function padLeft(str, length) {
  var paddedString = str;

  for (var l = str.length; l < length; l += 1, paddedString += ' ') {
    ;
  }

  return paddedString;
};

exports.padLeft = padLeft;